/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "ebdc347d1b101ae0cc55a6f1585185d442132561";
